export default function ({ route, error, redirect }) {
  const query = Object.assign({}, route.query);
  if (route.path.indexOf('/zh-hk') === 0) {
    let url = route.path.replace(/^\/zh-hk/, '');
    if (JSON.stringify(query) !== '{}') {
      url = `${url}?`;
      for (const prop in query) {
        url = `${url}${prop}=${query[prop]}&`;
      }
    }
    return redirect(url);
  }
  if (query.reform) {
    let url = decodeURIComponent(query.reform);
    delete query.reform;
    if (query.code) {
      if (!url.includes('?')) {
        url = `${url}?wxcode=${query.code}`;
      } else {
        url = `${url}&wxcode=${query.code}`;
      }
      for (const prop in query) {
        if (query[prop] !== 'undefined' && prop !== 'code') {
          url = `${url}&${prop}=${query[prop]}&`;
        }
      }
    }
    return redirect(url);
  }
}
